import NewTimerList from "../components/newtimerlist";
import { connect } from "react-redux";
import { fetchTimerPagination } from "../actions/newTimerAction";
import { archive } from "../actions/timerActions";
const NewTimerListContainer = (props) => {
  return <NewTimerList {...props} />;
};

const mapStateToProps = (state, props) => {
  return {
    envContext: state.envContext?.data ?? {},
    templates: state.template?.data ?? {},
    user: state.auth?.data ?? {},
    subaccounts: state.timers?.subaccounts ?? {},
    newTimer: state.newTimer ?? {},
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetch: (page, archived, searchText, currentSort, setLoading) => {
    dispatch(
      fetchTimerPagination(page, archived, searchText, currentSort, setLoading)
    );
  },
  archive: (timerId, archived, page) => {
    dispatch(archive(timerId, archived, page));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewTimerListContainer);
